import React from 'react';
import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../../../Services/AppContext';
import { loadDOMComponent } from '../../../../helpers';
import { store } from '../../../../store/store';
import { Provider } from 'react-redux';
import PatientManualRegistrationButton from './PatientManualRegistrationButton';
import { NCZICommandContextProvider } from '../../../Nczi/Services/NCZICommandContext';
import { NCZIContextProvider } from '../../../Nczi/Services/NCZIContext';

loadDOMComponent({
	selector: 'react-patient-manual-registration-button',
	callback: ({ container, context }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<NCZICommandContextProvider>
						<NCZIContextProvider>
							<PatientManualRegistrationButton reloadData={() => {}} />
						</NCZIContextProvider>
					</NCZICommandContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
